export const urlBehindTheSeizure = 'https://www.invitae.com/en/behindtheseizure/';
export const urlBiomarinContactForm = 'https://www.biomarin.com/web+request+form+for+commercial+sites';